<div class="mt-5">
  <h5 class="ps-2">
    {{ "Filters" | translate }}
  </h5>

  <form [formGroup]="filterForm" class="mt-3 mb-3">
    <formly-form [fields]="filterFields" [form]="filterForm"></formly-form>
  </form>

  <div class="d-flex justify-content-center gap-2 mb-5 mb-lg-0">
    <button
      [class.loading]="(loadingService.loading$ | async) || filterForm.pending"
      (click)="applyFilters()"
      class="btn btn-primary btn-block mb-0"
    >
      {{ "Apply" | translate }}
    </button>

    <button
      [class.loading]="(loadingService.loading$ | async) || filterForm.pending"
      (click)="resetFilters()"
      class="btn btn-secondary btn-block mb-0"
    >
      {{ "Reset" | translate }}
    </button>
  </div>
</div>
